module.exports = __webpack_public_path__ + "img/5a39398.png";